import React, { useState, useEffect } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { makeStyles, TextField } from "@material-ui/core";
import { getSchedule, findLoginId, getSchedule1 } from "../modules/api";
import { Calendar, momentLocalizer } from "react-big-calendar";
import Moment from "moment";
import {
  MonthlyBody,
  MonthlyDay,
  MonthlyCalendar,
  MonthlyNav,
  DefaultMonthlyEventItem,
} from "@zach.codes/react-calendar";
import { format, subHours, startOfMonth } from "date-fns";
import "../scss/fullcalendar.scss";
// import "@zach.codes/react-calendar/dist/calendar-tailwind.css";
// import "react-big-calendar/lib/sass/styles";
import "react-big-calendar/lib/css/react-big-calendar.css";

export function Schedule() {
  const [isShow, setIsShow] = useState(false);
  const [isDayShow, setIsDayShow] = useState(false);
  const [scheduleList, setScheduleList] = useState([]);
  const [scheduleDetail, setScheduleDetail] = useState([]);
  const [selectEvents, setSelectEvents] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(startOfMonth(new Date()));
  const toggleShow = () => {
    setIsShow(!isShow);
  };
  const localizer = momentLocalizer(Moment);
  const [botAdminList, setBotAdminList] = useState([]);
  const [botAdminId, setBotAdminId] = useState();
  const [change, setChange] = useState();

  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
  }));
  const classes = useStyles();

  // The first commit of Material-UI
  const [selectedDate, setSelectedDate] = useState(
    new Date("2014-08-18T21:11:54")
  );

  const fetchData = async (value, value1) => {
    try {
      console.log("value", value);
      console.log("value1", value1);
        const noticeNow = new Date();
      // const nowYear = new Date().getFullYear();
      // const nowMonth = new Date().getMonth();
      let lastDay = "";
      if (value) {
        const dateInfo = value.split("-");
        lastDay = new Date(dateInfo[0], dateInfo[1], 0).getDate();
      } else {
        const nowYear = new Date().getFullYear();
        const nowMonth = new Date().getMonth();
        lastDay = new Date(nowYear, nowMonth + 1, 0).getDate();
      }

      let now;
      if (value === undefined) {
        now = Moment(new Date()).format("YYYY-MM");
      } else {
        now = value;
      }
      console.log(lastDay);
      console.log("nownow", now);
      const stDate = now + "-01";
      const edDate = now + "-" + lastDay;
      // const stDate = nowYear + "-01-01";
      // const edDate = nowYear + "-12-31";
      // const result = await getSchedule(stDate, edDate);
      let result;
      const role = localStorage.getItem("userRole");
      if (role === "SystemAdmin") {
        const botAdminList = await findLoginId();
        console.log("botAdminList", botAdminList);
        setBotAdminList(botAdminList.data);
        console.log("botAdminId", botAdminId);
        result = await getSchedule1(stDate, edDate, value1);
      } else {
        result = await getSchedule(stDate, edDate);
      }

      console.log("getSchedule", result);
      let list = [];
      result.data.map((data, index) => {
        if (data.schedules != null) {
          // console.log("data", data);
          // console.log("index", index);
          let exeDate = data.date;
          data.schedules.map((data, index) => {
            var obj = new Object();
            obj.id = data.no;
            obj.botNo = data.botNo;
            obj.botName = data.botLoginId;
            obj.title =
              data.startTime.substring(0, 2) +
              ":" +
              data.startTime.substring(2, 4) +
              "   " +
              data.scheduleName;
            obj.exeName = data.scheduleName;
            obj.start = new Date(
              parseInt(exeDate.substring(0, 4)),
              parseInt(exeDate.substring(5, 7) - 1),
              parseInt(exeDate.substring(8, 10)),
              parseInt(data.startTime.substring(0, 2)),
              parseInt(data.startTime.substring(2, 4))
            );
            obj.end = new Date(
              parseInt(exeDate.substring(0, 4)),
              parseInt(exeDate.substring(5, 7) - 1),
              parseInt(exeDate.substring(8, 10)),
              parseInt(data.endTime.substring(0, 2)),
              parseInt(data.endTime.substring(2, 4))
            );
            obj.allDay = false;
            obj.exeTime = data.startTime;
            obj.scheduleType = data.scheduleType;
              if (exeDate > Moment(new Date()).format("YYYY-MM-DD") || data.status == 0) {
                  obj.color = "var(--gray)";
              }
              else if (data.status == 1) {
                  obj.color = "var(--success)";
              }
              else if (data.status == 2) {
                  obj.color = "var(--primary)";
              }
            obj.status = data.status;
            list.push(obj);
          });
        }
      });
        console.log("getSchedule2", list);
      setScheduleList(list);
    } catch (e) {
      console.log(e);
      // Handle error
    }
  };

  useEffect(() => {
    // setListLoading(true);
    // setTimeout(async () => {
    fetchData();
    // 	setListLoading(false);
    // }, 1000);
  }, []);

  const selectDate = () => {
    console.log("selectDate");
    setIsShow(true);
  };

  const selectEvent = (event) => {
    console.log("selectEvent", event);
    setScheduleDetail(event);
    setIsShow(true);
  };

  const changeSchedule = (date) => {
    // 이벤트 잔상으로 인해 state 초기화
    setScheduleList([]);
    const changeDate = Moment(date).format("YYYY-MM");
    console.log("changeDate", changeDate);
    setChange(changeDate);
    fetchData(changeDate, botAdminId);
  };

  const CustomToolbar = (toolbar) => {
    console.log("toolbar", toolbar);

    return (
      <div className="rbc-toolbar">
        <div className="rbc-btn-group">
          <button type="button" onClick={() => toolbar.onNavigate("TODAY")}>
            Today
          </button>
          <button type="button" onClick={() => toolbar.onNavigate("PREV")}>
            Previous
          </button>
          <button type="button" onClick={() => toolbar.onNavigate("NEXT")}>
            Next
          </button>
        </div>
        <div className="rbc-toolbar-label">
          {Moment(toolbar.date).format("YYYY-MM")}
        </div>
        <div className="rbc-btn-group">
          <button type="button" onClick={() => toolbar.onView("month")}>
            Month
          </button>
          {/* <button type="button" onClick={() => toolbar.onView("week")}>
						Week
					</button>
					<button type="button" onClick={() => toolbar.onView("day")}>
						Day
					</button> */}
        </div>
      </div>
    );
  };

  return (
    <div id="pageid25">
      {/* D6: 예약 항목 선택 시 예약 상세 시작 */}
      <Modal
        show={isShow}
        onHide={toggleShow}
        // aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">예약 상세</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <table
              className="table table-head-custom table-vertical-center bg-white w-100"
              id="kt_advance_table_widget_1"
            >
              <thead>
                <tr className="text-left">
                  <th>Bot ID</th>
                  <th>예약명</th>
                  <th>예약 시간</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{scheduleDetail.botName}</td>
                  <td style={{whiteSpace: "nowrap",overflow: "hidden", textOverflow: "ellipsis"}}  title={scheduleDetail.exeName}>{scheduleDetail.exeName}</td>
                  <td>
                    {scheduleDetail.scheduleType === 1 ? "매일" : ""}{" "}
                    {scheduleDetail.exeTime &&
                      scheduleDetail.exeTime.substring(0, 2) +
                        ":" +
                        scheduleDetail.exeTime.substring(2, 4)}
                  </td>
                  <td>
                    <span
                      className="label label-xl label-inline"
                      style={{
                        background: scheduleDetail.color,
                        color: "white",
                      }}
                    >
                      {scheduleDetail.status === 0 && "미실행"}
                      {scheduleDetail.status === 1 && "성공"}
                      {scheduleDetail.status === 2 && "실패"}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={() => setIsShow(false)}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        show={isDayShow}
        // aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">예약 상세</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <table
              className="table table-head-custom table-vertical-center bg-white w-100"
              id="kt_advance_table_widget_1"
            >
              <thead>
                <tr className="text-center">
                  <th>Bot ID</th>
                  <th>예약명</th>
                  <th>예약 시간</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                {selectEvents.length > 0 &&
                  selectEvents.map((data, index) => {
                    return (
                      <tr>
                        <td>{data.botName}</td>
                            <td style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={data.exeName}>{data.exeName}</td>
                        <td>
                          {data.scheduleType === 1 ? "매일" : ""}{" "}
                          {data.exeTime &&
                            data.exeTime.substring(0, 2) +
                              ":" +
                              data.exeTime.substring(2, 4)}
                        </td>
                        <td>
                          <span
                            className="label label-xl label-inline"
                            style={{
                              background: data.color,
                              color: "white",
                            }}
                          >
                            {(() => {
                                switch (data.status) {
                                    case 0: return "미실행";
                                    case 1: return "성공";
                                    case 2: return "실패";
                                    default: return "미실행";
                                }
                            })()}

                          </span>
                        </td>
                      </tr>
                    );
                  })}
                {/* <tr>
									<td>Logan1</td>
									<td>실행 예약</td>
									<td>[날짜] 매일 오후 05:00</td>
									<td>
										<span className="label label-xl label-inline label-warning">
											실행중
										</span>
									</td>
								</tr> */}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={() => setIsDayShow(false)}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      {/* D6: 예약 항목 선택 시 예약 상세 끝 */}
      <div
        className="d-flex align-items-center justify-content-between w-100"
        style={{ marginTop: 30 }}
      >
        <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
          예약 관리
        </h3>
        {localStorage.getItem("userRole") === "SystemAdmin" && (
          <div className="fv-plugins-icon-container mr-5">
            <select
              className="form-control form-control-lg form-control-solid"
              style={{ borderColor: "black", width: "200px" }}
              name="botAdminList"
              onChange={(e) => {
                setBotAdminId(e.target.value);
                fetchData(change, e.target.value);
              }}
            >
              <option value="">선택</option>
              {botAdminList &&
                botAdminList.length > 0 &&
                botAdminList.map((data, index) => {
                  return <option value={data.no}>{data.loginId}</option>;
                })}
            </select>
          </div>
        )}
      </div>

      <div className="gutter-b calendar-top" style={{ marginTop: 50 }}>
        <div>
          <ul className="d-flex justify-content-end">
            <li style={{ backgroundColor: "white" }}>
              <span style={{ background: "var(--gray)" }}></span>미실행
            </li>
            <li style={{ backgroundColor: "white" }}>
              <span style={{ background: "var(--warning)" }}></span>실행중
            </li>
            <li style={{ backgroundColor: "white" }}>
              <span style={{ background: "var(--success)" }}></span>성공
            </li>
            <li style={{ backgroundColor: "white", paddingRight: 20 }}>
              <span style={{ background: "var(--primary)" }}></span>실패
            </li>
          </ul>
        </div>
      </div>
      <div className="gutter-b">
        <div className="fc-view-container fc-unthemed fc">
          <div className="fc-view fc-month-view">
            <Calendar
              selectable
              localizer={localizer}
              events={scheduleList}
              startAccessor="start"
              endAccessor="end"
              views={["month", "week", "day"]}
              style={{ height: 700 }}
              // onSelectSlot={selectDate}
              onSelectEvent={(event) => selectEvent(event)}
              onShowMore={(events, date) => {
                // console.log("setSelectEvents", events);
                setSelectEvents(events);
                setIsDayShow(true);
              }}
              doShowMoreDrillDown={false}
              components={{
                toolbar: CustomToolbar,
              }}
              popup={false}
              onNavigate={(date) => {
                // console.log(date);
                changeSchedule(date);
              }}
              eventPropGetter={(event, start, end, isSelected) => ({
                style: {
                  backgroundColor: isSelected ? "green" : event.color,
                },
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Schedule;
